module.exports = __webpack_public_path__ + "img/_DSC1287.33aed727.jpg";